import {
  Box,
  Button,
  Container,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { FaRegCirclePlay } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/colorLogo.png";
import Layout from "../../../components/student/Layout/layout";
import { getEnrolledCoursesRequest } from "../../../modules/students-modules/courses/Actions";

const StudyCoursesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, courses } = useSelector((state) => state.studentCourses);

  useEffect(() => {
    dispatch(getEnrolledCoursesRequest());
  }, []);

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" px="20px" mt={100}>
        <VStack spacing={12}>
          <VStack spacing={6} align="stretch">
            <Box
              bg="white"
              borderRadius="xl"
              p={6}
            >
              {courses?.length == 0 ? (
                <Stack alignItems="center" width="100%">
                  <Text>No Courses Yet? Enroll now!</Text>
                  <Button
                    bg="main_1"
                    color="white"
                    onClick={() => {
                      navigate("/teachers");
                    }}
                  >
                    Go to Teachers
                  </Button>
                </Stack>
              ) : (
                <Stack flexDirection={{ base: "column", md: "row" }} gap={5}>
                  {courses?.map((data, index) => {
                    return (
                      <Box
                      w={{base:'100%',md:'30%'}}
                        key={index}
                        bg="blackAlpha.200"
                        borderRadius={16}
                        display="flex !important"
                        flexDirection="column"
                        onClick={() =>
                          navigate(`/study-with-agwad/${data?.id}`)
                        }
                        role="group"
                        cursor="pointer"
                        _hover={{
                          transition: "500ms ease-in-out",
                        }}
                      >
                        <Box overflow="hidden">
                          <Image
                            src={Logo}
                            alt="Green double couch with wooden legs"
                            borderTopRadius="lg"
                            _groupHover={{
                              transform: "scale(1.2)",
                              transition: "500ms ease-in-out",
                            }}
                          />
                        </Box>
                        <Stack spacing="2" p={5}>
                          <Text color="main_1" fontSize={20} fontWeight={600}>
                            {data?.name}
                          </Text>
                          <Text color="main_1" fontSize={16}>
                            {data?.subjects?.[0]?.name}
                          </Text>

                          <Stack
                            flexDirection="row"
                            alignItems="center"
                            gap={2}
                          >
                            <FaRegCirclePlay color="#8196df" size={20} />{" "}
                            <Text mt="-1px !important">
                              {data?.chapters?.length} Chapter
                              {data?.chapters?.length > 1 ? "s" : ""}
                            </Text>
                          </Stack>
                        </Stack>
                      </Box>
                    );
                  })}
                </Stack>
              )}
            </Box>
          </VStack>
        </VStack>
      </Container>
    </Layout>
  );
};

export default StudyCoursesList;
